/* global window */
const getSite = () => {
	const { pathname } = window.location;
	if (pathname.match(/^[/]so/)) return 3;
	if (pathname.match(/^[/]es/)) return 2;
	return 1;
};

export default getSite;
